module.exports = __webpack_public_path__ + "static/img/mini-bus-bluegrey.c9ceaee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-bluegrey.svg
// module id = ZdM5
// module chunks = 74